import type { PaymentReader } from "@/types";

export function isReaderPaired(
  reader: Pick<PaymentReader, "id" | "serial_number"> | null | undefined,
): boolean {
  return Boolean(reader?.id && reader.serial_number.trim());
}
